import { useState, useEffect } from "react";
import "./App.css";
import "./responsive.css";
// import dubaiImg from './dubaiImg.jpeg';
import dubaiImgXs from './hero-banner-xs.png';
import ainxtLogo from './ainxt_logo.png';


function App() {

  const USE_FAKE_OTP = false;
  // SEND-OTP API config
  // Absolute URL per provided cURL (bypasses dev proxy)
  const SEND_OTP_URL = "https://rg0404cat7.execute-api.ap-south-1.amazonaws.com/v1/uat";
  const SEND_OTP_API_KEY = "pf9EpIh62Z1KCh31Iq0x74e3IM4hJIsb2E7HcDiH"; // replace if you rotate keys
  const VERIFY_OTP_URL = "https://rg0404cat7.execute-api.ap-south-1.amazonaws.com/v1/uat/client_verify_otp";
  const VERIFICATION_EMAIL_URL = "https://rg0404cat7.execute-api.ap-south-1.amazonaws.com/v1/uat/verification_email";
  const VOICE_AGENT_URL = "https://api.ainxtapi.com:8888/dispatch";
  const VOICE_AGENT_API_KEY = "Voice_agent_ainxt";
  const RESEND_OTP_URL = "https://rg0404cat7.execute-api.ap-south-1.amazonaws.com/v1/uat/client_resend_otp";
  const RESEND_OTP_API_KEY = "pf9EpIh62Z1KCh31Iq0x74e3IM4hJIsb2E7HcDiH";
  const [isOpen, setIsOpen] = useState(false);
  const [modalStep, setModalStep] = useState("form");
  const [formData, setFormData] = useState({
    fullName: "",
    mobile: "",
    email: "",
    useCase: "kyc",
  });
  const [errors, setErrors] = useState({});
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState({ success: false, message: "" });
  const [otpSeconds, setOtpSeconds] = useState(120);
  // const [overlayVisible, setOverlayVisible] = useState(false);
  const [heroStep, setHeroStep] = useState(0); // 0: waiting, 1: title, 2: button

  // CAPTCHA state
  const [showCaptcha, setShowCaptcha] = useState(false);
  const [captchaValue, setCaptchaValue] = useState('');
  const [captchaInput, setCaptchaInput] = useState('');
  const [captchaError, setCaptchaError] = useState('');
  const [kycConfirmed, setKycConfirmed] = useState(true);
  const [resendCooldown, setResendCooldown] = useState(0);
  const [isResending, setIsResending] = useState(false);

  const useCaseMap = {
    kyc: "KYC Journey",
    feedback: "Customer Feedback",
    health: "Health Insurance",
    collections: "Collections/EMIs"
  };
  const demoType = useCaseMap[formData.useCase] || formData.useCase;

  const resetForm = () => {
    setFormData({ fullName: "", mobile: "", email: "", useCase: "kyc" });
    setErrors({});
    setOtp("");
    setOtpError("");
    setIsLoading(false);
    setResult({ success: false, message: "" });
    setModalStep("form");
    setOtpSeconds(120);
    setShowCaptcha(false);
    setCaptchaValue('');
    setCaptchaInput('');
    setCaptchaError('');
    setKycConfirmed(true);
    setResendCooldown(0);
    setIsResending(false);
  };

  const openModal = () => {
    resetForm();
    setIsOpen(true);
    // Show CAPTCHA immediately when modal opens
    setShowCaptcha(true);
    // Generate CAPTCHA after a short delay to ensure canvas is rendered
    setTimeout(() => {
      generateCaptcha();
    }, 100);
  };

  const closeModal = () => {
    setIsOpen(false);
    resetForm();
  };

  // Countdown timer for OTP step
  useEffect(() => {
    if (modalStep !== "otp") return;
    setOtpSeconds(120);
    const timer = setInterval(() => {
      setOtpSeconds((s) => (s > 0 ? s - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, [modalStep]);

  const formatTime = (s) => {
    const mm = String(Math.floor(s / 60)).padStart(2, "0");
    const ss = String(s % 60).padStart(2, "0");
    return `${mm}:${ss}`;
  };

  // CAPTCHA functions
  const generateCaptcha = () => {
    const canvas = document.getElementById('captchaCanvas');
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Background
    ctx.fillStyle = "#f2f2f2";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Generate 4-digit random number
    let newCaptchaValue = '';
    for (let i = 0; i < 4; i++) {
      newCaptchaValue += Math.floor(Math.random() * 10);
    }
    setCaptchaValue(newCaptchaValue);

    // Add noise lines
    for (let i = 0; i < 5; i++) {
      ctx.strokeStyle = "#aaa";
      ctx.beginPath();
      ctx.moveTo(Math.random() * 150, Math.random() * 50);
      ctx.lineTo(Math.random() * 150, Math.random() * 50);
      ctx.stroke();
    }

    // Draw digits with random position/rotation
    for (let i = 0; i < newCaptchaValue.length; i++) {
      ctx.save();
      const angle = (Math.random() - 0.5) * 0.5; // random rotation
      ctx.translate(30 * i + 15, 35);
      ctx.rotate(angle);
      ctx.font = "28px Arial";
      ctx.fillStyle = "#333";
      ctx.fillText(newCaptchaValue[i], -10, 5);
      ctx.restore();
    }
  };

  const validateCaptcha = () => {
    if (captchaInput.length !== 4) {
      setCaptchaError('Please enter exactly 4 digits.');
      return false;
    }

    if (captchaInput === captchaValue) {
      setCaptchaError('');
      setShowCaptcha(false);
      return true;
    } else {
      setCaptchaError('Incorrect CAPTCHA, try again.');
      generateCaptcha(); // Refresh CAPTCHA
      setCaptchaInput('');
      return false;
    }
  };

  // On mount: show background first, then staged hero reveal after 2s
  useEffect(() => {
    const overlayTimer = setTimeout(() => {
      setTimeout(() => setHeroStep(1), 300);
      setTimeout(() => setHeroStep(2), 700);
    }, 2000);
    return () => clearTimeout(overlayTimer);
  }, []);

  const persistEnrollment = (data) => {
    try {
      const key = "enrollments";
      const existing = JSON.parse(localStorage.getItem(key) || "[]");
      const toSave = {
        ...data,
        savedAt: new Date().toISOString(),
      };
      existing.push(toSave);
      localStorage.setItem(key, JSON.stringify(existing));
    } catch (e) {
      // best-effort, ignore storage errors
      console.warn("Failed to persist enrollment", e);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let sanitized = value;

    if (name === "fullName") {
      sanitized = value.replace(/[^a-zA-Z\s]/g, "");
      sanitized = sanitized.replace(/\s{2,}/g, " ");
    }

    if (name === "mobile") {
      sanitized = value.replace(/[^0-9]/g, "");
    }

    if (name === "email") {
      // Allow basic email charset only
      sanitized = value.replace(/[^A-Za-z0-9@._+-]/g, "");
      // Keep only the first '@'
      const firstAt = sanitized.indexOf("@");
      if (firstAt !== -1) {
        const before = sanitized.slice(0, firstAt + 1);
        const after = sanitized.slice(firstAt + 1).replace(/@/g, "");
        sanitized = before + after;
      }
      // Prevent consecutive dots
      sanitized = sanitized.replace(/\.{2,}/g, ".");
      // Trim leading dots or @
      sanitized = sanitized.replace(/^[@.]+/, "");
      // Limit length to a typical max
      if (sanitized.length > 254) sanitized = sanitized.slice(0, 254);
    }

    if (name === "otp") {
      const cleaned = value.replace(/[^0-9]/g, "").slice(0, 5);
      setOtp(cleaned);
      setOtpError(cleaned.length === 5 ? "" : "Enter 5-digit OTP");
      return;
    }

    // Update value first
    const updated = { ...formData, [name]: sanitized };
    setFormData(updated);

    // Always validate on change
    const fieldError = validateField(name, sanitized);
    setErrors({ ...errors, [name]: fieldError || "" });
  };

  // Restricted email domains
  const restrictedDomains = [
    "gmail.com",
    "google.com",
    "yahoo.com",
    "hotmail.com",
    "aol.com",
    "outlook.com",
    "live.com",
    "msn.com",
    "icloud.com",
    "me.com",
    "mac.com",
    "protonmail.com",
    "yandex.com",
    "mail.ru",
    "rediffmail.com",
    "zoho.com"
  ];

  const validateField = (fieldName, fieldValue) => {
    const value = (fieldValue ?? formData[fieldName] ?? "").trim();
    switch (fieldName) {
      case "fullName":
        if (!value) return "Full name is required";
        if (value.length < 2 || value.length > 50) return "Name must be 2-50 chars";
        if (!/^[A-Za-z ]+$/.test(value)) return "Only letters and spaces allowed";
        return "";
      case "mobile":
        if (!value) return "Mobile number is required";
        if (!/^[6-9]\d{9}$/.test(value)) return "Enter 10 digits starting with 6-9";
        return "";
      case "email":
        if (!value) return "Email is required";
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) return "Enter a valid email";

        // Check for restricted domains
        const emailParts = value.split("@");
        if (emailParts.length === 2) {
          const domain = emailParts[1].toLowerCase();
          if (restrictedDomains.includes(domain)) {
            return `Please use a business or custom domain.`;
          }
        }
        return "";
      default:
        return "";
    }
  };

  const validate = () => {
    const newErrors = {};
    ["fullName", "mobile", "email", "useCase"].forEach((f) => {
      const err = validateField(f, formData[f]);
      if (err) newErrors[f] = err;
    });

    // Check KYC confirmation
    if (!kycConfirmed) {
      newErrors.kycConfirmed = " I confirm that this demo call is intended for the selected use case only.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    // Validate CAPTCHA
    if (!validateCaptcha()) {
      return;
    }

    try {
      // Persist locally so it's not lost on reload
      persistEnrollment(formData);
      // OTP SEND FLOW
      // If you're integrating a real API, set USE_FAKE_OTP = false and use the fetch below.
      setIsLoading(true);
      if (USE_FAKE_OTP) {
        // FAKE: simulate send-otp success
        await new Promise((r) => setTimeout(r, 800));
        setIsLoading(false);
        setModalStep("otp");
        setOtpSeconds(120);
        return;
      }

      // REAL: send OTP to backend
      const response = await fetch(SEND_OTP_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": SEND_OTP_API_KEY,
        },
        // API expects: name, email_id, phoneNumber
        body: JSON.stringify({
          name: formData.fullName,
          email_id: formData.email,
          phoneNumber: formData.mobile,
        }),
        body: JSON.stringify({
          name: formData.fullName,
          email_id: formData.email,
          phoneNumber: formData.mobile,
          demoType: demoType
        }),
      });
      const data = await response.json();
      setIsLoading(false);
      if (response.ok) {
        setModalStep("otp");
        setOtpSeconds(120);
      } else {
        setResult({ success: false, message: data.message || "Failed to send OTP" });
        setModalStep("result");
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      setResult({ success: false, message: "Failed to send OTP" });
      setModalStep("result");
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    const trimmed = otp.trim();
    if (!/^\d{5}$/.test(trimmed)) {
      setOtpError("Enter 5-digit OTP");
      return;
    }
    try {
      setIsLoading(true);
      if (USE_FAKE_OTP) {
        // FAKE: simulate verification - check if OTP is "12345" for success
        await new Promise((r) => setTimeout(r, 900));
        setIsLoading(false);

        if (trimmed === "12345") {
          // Success case
          setResult({ success: true, message: "Demo Scheduled Successfully.\nYou're moments away from experiencing the\n future of AI voice conversations.\n Our agent will connect with you shortly." });
          setModalStep("result");
        } else {
          // Invalid OTP case
          setOtpError("Invalid OTP, please try again.");
          setOtp(""); // Clear the OTP input
          // Stay on OTP step for retry
        }
        return;
      }

      // REAL: verify OTP with backend (per provided cURL)
      const response = await fetch(VERIFY_OTP_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": SEND_OTP_API_KEY,
        },
        body: JSON.stringify({ phoneNumber: formData.mobile, otp: trimmed }),
      });
      const data = await response.json();

      if (response.ok) {
        // OTP verification successful, now send verification email and dispatch voice agent
        try {
          // Call both APIs in parallel for better performance
          const [emailResponse, voiceResponse] = await Promise.allSettled([
            // Email verification API
            fetch(VERIFICATION_EMAIL_URL, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "x-api-key": SEND_OTP_API_KEY,
              },
              body: JSON.stringify({ phoneNumber: formData.mobile }),
            }),
            // Voice agent dispatch API
            fetch(VOICE_AGENT_URL, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-API-Key": VOICE_AGENT_API_KEY,
              },
              body: JSON.stringify({
                phone_number: formData.mobile,
                demo_type: demoType // <-- added demo type
              }),
            })
          ]);

          // Check results of both APIs
          const emailSuccess = emailResponse.status === 'fulfilled' && emailResponse.value.ok;
          const voiceSuccess = voiceResponse.status === 'fulfilled' && voiceResponse.value.ok;

          // Determine success message based on API results
          let message = "Demo Scheduled Successfully.\nYou're moments away from experiencing the future of AI voice conversations. Our agent will connect with you shortly.";

          if (!emailSuccess && !voiceSuccess) {
            message = "Demo confirmed! We'll contact you shortly. Note: Both verification email and call dispatch failed, but your registration is complete.";
          } else if (!emailSuccess) {
            message = "Demo confirmed! Our AI agent will call you shortly. Note: Verification email failed to send.";
          } else if (!voiceSuccess) {
            message = "Demo confirmed! Verification email sent. Note: Call dispatch failed, we'll contact you via email.";
          }

          setResult({ success: true, message: message });

        } catch (error) {
          console.error("Post-verification APIs failed:", error);
          // OTP successful but post-APIs failed - still show success
          setResult({
            success: true,
            message: "Demo confirmed! Your registration is complete. We'll contact you shortly."
          });
        }
      } else {
        // Invalid OTP - stay on OTP step and show error
        setOtpError(data.message || "Invalid OTP, please try again.");
        setOtp(""); // Clear the OTP input
        setIsLoading(false);
        // Don't change modalStep - stay on "otp"
        return;
      }
      setIsLoading(false);
      setModalStep("result");
    } catch (err) {
      console.error(err);
      setIsLoading(false);
      setOtpError("Verification failed. Please try again.");
      setOtp(""); // Clear the OTP input
      // Stay on OTP step for retry
    }
  };

  const handleResendOtp = async () => {
    if (resendCooldown > 0 || isResending) return;

    try {
      setIsResending(true);
      setOtpError("");

      // Use the dedicated resend OTP API endpoint
      const response = await fetch(RESEND_OTP_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": RESEND_OTP_API_KEY,
        },
        body: JSON.stringify({
          phoneNumber: formData.mobile,
        }),
      });

      if (response.ok) {
        // Reset OTP timer and cooldown
        setOtpSeconds(120);
        setResendCooldown(30); // 30 second cooldown
        setOtp(""); // Clear current OTP input

        // Start cooldown timer
        const cooldownInterval = setInterval(() => {
          setResendCooldown(prev => {
            if (prev <= 1) {
              clearInterval(cooldownInterval);
              return 0;
            }
            return prev - 1;
          });
        }, 1000);

        // Show success message
        setOtpError(""); // Clear any previous errors
      } else {
        const data = await response.json();
        setOtpError(data.message || "Failed to resend OTP. Please try again.");
      }
    } catch (error) {
      console.error("Resend OTP error:", error);
      setOtpError("Failed to resend OTP. Please try again.");
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="App">

      {/* Dubai 2025 AI Agentic Voice Launch Poster */}
      <div className="dubai-poster">
        {/* Top Section */}
        <div className="poster-top">
          <div className="top-left">
            <div className="logo-section">
              <div className="ainxt-logo">
                <img
                  src={ainxtLogo}
                  alt="AiNxt.Tech Logo"
                  className="ainxt-logo-img"
                  onError={(e) => console.log('Logo image failed to load:', e)}
                  onLoad={() => console.log('Logo image loaded successfully')}
                />
              </div>
            </div>
            <div className="dubai-text">
              <span className="airplane-icon">✈</span>
              <span>DUBAI</span>
            </div>
          </div>

          {/*<div className="top-divider"></div>*/}

          <div className="top-right">
            <div className="event-date">DUBAI 2025</div>
            <div className="event-title">Global Launch of Human-Like Voice AI</div>
          </div>
        </div>



        {/* Main Section */}
        <div className="poster-main">

          <div className="main-content">
            <div className="main-left">
              {/*content*/}
              <div className="content">
                <h1 className="title">
                  VedVani: Experience Human-Like <span className="mobile-break">Conversations Powered by AiNXT</span>
                </h1>
                <button
                  onClick={openModal}
                  className="cta-button"
                >
                  Book Your Live Demo Now
                </button>

                <div className="ainxt-text">
                  <div className="company-name">AiNXT</div>
                  <div className="company-tagline">GOES GLOBAL</div>
                </div>

              </div>
            </div>
            <div className="show-mobile hide-desktop hero-banner-xs">
              <img src={dubaiImgXs} alt="Burj Khalifa Building" className="hero-banner-xs-img img-fluid" />
            </div>
            <div className="main-right">
              <div className="unveiling-box">UNVEILING</div>
              <div className="ai-features">
                <div className="feature-line">HUMAN-LIKE AI</div>
                <div className="feature-line">CONVERSATIONS</div>
              </div>
              <div className="ai-nxt-vc-icon">
                <img src="/icon-ai-voice.svg" alt="icon-ai-voice" />
              </div>
              <div className="VedVani">VEDVANI</div>
            </div>
          </div>

        </div>
      </div>

      {/* Modal */}
      {isOpen && (
        <div className="modal-backdrop">
          <div className="modal">
            <button
              className="modal-close"
              onClick={closeModal}
            >
              ✕
            </button>
            <h2 className="modal-title">Enroll For Live Demo</h2>
            {modalStep === "form" && (
              <form onSubmit={handleSubmit} className="form" noValidate>
                <input
                  type="text"
                  name="fullName"
                  placeholder="Full Name"
                  maxLength={50}
                  value={formData.fullName}
                  onChange={handleChange}
                  onBlur={(e) => setErrors({ ...errors, fullName: validateField("fullName", e.target.value) })}
                  className={`input${errors.fullName ? " input-error" : ""}`}
                  aria-invalid={!!errors.fullName}
                  aria-describedby="error-fullName"
                  required
                />
                {errors.fullName && (
                  <div id="error-fullName" className="error-text">{errors.fullName}</div>
                )}
                <input
                  type="tel"
                  name="mobile"
                  placeholder="Mobile No"
                  value={formData.mobile}
                  onChange={handleChange}
                  onBlur={(e) => setErrors({ ...errors, mobile: validateField("mobile", e.target.value) })}
                  className={`input${errors.mobile ? " input-error" : ""}`}
                  inputMode="tel"
                  pattern="^[6-9]\\d{9}$"
                  maxLength={10}
                  aria-invalid={!!errors.mobile}
                  aria-describedby="error-mobile"
                  required
                />
                {errors.mobile && (
                  <div id="error-mobile" className="error-text">{errors.mobile}</div>
                )}
                <input
                  type="email"
                  name="email"
                  placeholder="Business Email Address"
                  value={formData.email}
                  onChange={handleChange}
                  onBlur={(e) => setErrors({ ...errors, email: validateField("email", e.target.value) })}
                  className={`input${errors.email ? " input-error" : ""}`}
                  aria-invalid={!!errors.email}
                  aria-describedby="error-email"
                  required
                />
                {errors.email && (
                  <div id="error-email" className="error-text">{errors.email}</div>
                )}
                <input
                  type="text"
                  name="useCase"
                  value="KYC onboarding"
                  readOnly
                  disabled
                  className="input input-disabled"
                  style={{ cursor: 'not-allowed', pointerEvents: 'none' }}
                />
                {/* CAPTCHA Section */}
                {showCaptcha && (
                  <div className="captcha-section" >
                    <h3>Please enter the number shown in the image:</h3>
                    <div className="captcha-container">
                      <canvas id="captchaCanvas" width="120" height="50"></canvas>
                      <button
                        type="button"
                        onClick={generateCaptcha}
                        className="captcha-refresh-btn"
                        title="Refresh CAPTCHA"
                      >
                        🔄
                      </button>
                    </div>
                    <input
                      type="text"
                      id="captchaInput"
                      placeholder="Enter 4 digits"
                      value={captchaInput}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 4);
                        setCaptchaInput(value);
                        if (value.length === 4) {
                          setCaptchaError('');
                        }
                      }}
                      className={`captcha-input${captchaError ? " input-error" : ""}`}
                      maxLength={4}
                      inputMode="numeric"
                      pattern="[0-9]{4}"
                      required
                    />
                    {captchaError && (
                      <div className="error-text">{captchaError}</div>
                    )}
                  </div>
                )}

                {/* KYC Confirmation Checkbox */}
                <div className="kyc-confirmation">
                  <label className="checkbox-container">
                    <input
                      type="checkbox"
                      checked={kycConfirmed}
                      onChange={(e) => setKycConfirmed(e.target.checked)}
                      className="checkbox-input"
                    />
                    <span className="checkbox-text">
                      I confirm that this demo call is intended for the selected use case only.
                    </span>
                  </label>
                  {errors.kycConfirmed && (
                    <div className="error-text">{errors.kycConfirmed}</div>
                  )}
                </div>

                <div className="actions">
                  <button
                    type="button"
                    onClick={closeModal}
                    className="btn btn-secondary"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={
                      isLoading ||
                      !kycConfirmed ||
                      Object.values(errors).some(Boolean) ||
                      !formData.fullName?.trim() ||
                      !formData.mobile?.trim() ||
                      !formData.email?.trim() ||
                      !formData.useCase ||
                      (showCaptcha && captchaInput.length !== 4)
                    }
                  >
                    {isLoading ? "Sending..." : "Submit"}

                  </button>
                </div>
              </form>
            )}

            {modalStep === "otp" && (
              <form onSubmit={handleVerifyOtp} className="form" noValidate>
                <div className="subtitle" style={{ marginTop: -4, marginBottom: 8 }}>We sent an OTP to {formData.mobile}</div>
                <div className="subtitle" style={{ marginTop: -8, marginBottom: 16 }}>Time remaining: {formatTime(otpSeconds)}</div>

                <div className="otp-container">
                  <div className="otp-inputs">
                    {[...Array(5)].map((_, index) => (
                      <input
                        key={index}
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]"
                        maxLength={1}
                        className={`otp-box${otpError ? " otp-error" : ""}`}
                        value={otp[index] || ""}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9]/g, "");
                          if (value.length <= 1) {
                            const newOtp = otp.split("");
                            newOtp[index] = value;
                            setOtp(newOtp.join(""));
                            setOtpError("");

                            // Auto-focus next input
                            if (value && index < 4) {
                              const nextInput = e.target.nextElementSibling;
                              if (nextInput) nextInput.focus();
                            }
                          }
                        }}
                        onKeyDown={(e) => {
                          // Handle backspace
                          if (e.key === "Backspace" && !otp[index] && index > 0) {
                            const prevInput = e.target.previousElementSibling;
                            if (prevInput) prevInput.focus();
                          }
                        }}
                        onFocus={(e) => e.target.select()}
                        aria-invalid={!!otpError}
                        required
                      />
                    ))}
                  </div>
                </div>

                {otpError && (
                  <div id="error-otp" className="error-text">{otpError}</div>
                )}

                <div className="resend-otp-section" style={{ textAlign: 'center', margin: '16px 0' }}>
                  <button
                    type="button"
                    onClick={handleResendOtp}
                    className="btn-link"
                    disabled={resendCooldown > 0 || isResending}
                    style={{
                      background: 'none',
                      border: 'none',
                      color: resendCooldown > 0 || isResending ? '#999' : '#007bff',
                      textDecoration: 'underline',
                      cursor: resendCooldown > 0 || isResending ? 'not-allowed' : 'pointer',
                      fontSize: '14px',
                      padding: '8px'
                    }}
                  >
                    {isResending ? "Resending..." : resendCooldown > 0 ? `Resend OTP (${resendCooldown}s)` : "Resend OTP"}
                  </button>
                </div>

                <div className="actions">
                  <button type="button" onClick={() => setModalStep("form")} className="btn btn-secondary">Back</button>
                  &nbsp;&nbsp;
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={otp.length !== 5 || !!otpError || isLoading || otpSeconds === 0}
                  >
                    {isLoading ? "Verifying..." : otpSeconds === 0 ? "Expired" : "Verify"}
                  </button>
                </div>
              </form>
            )}

            {modalStep === "result" && (
              <div className="form">
                <div className={`status ${result.success ? "status-success" : "status-error"}`}>
                  {result.success ? (
                    <div>
                      <div className="status-title" align="center">Demo Scheduled Successfully.</div>
                      <br></br>
                      <div className="status-sub" align="center">You're moments away from experiencing the future <br />of AI voice conversations. Our agent will connect with you shortly.</div>
                    </div>
                  ) : (
                    <div>{result.message}</div>
                  )}
                </div>
                <div className="actions">
                  <button type="button" onClick={closeModal} className="btn btn-primary">OK</button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Footer with Copyright and Terms */}
      <footer className="footer">

        <div className="footer-content">
          <div className="contact-info">
            <span className="contact-email">
              Contact Us: <a href="mailto:Solutions@ainxttech.com" className="email-link">Solutions@ainxttech.com</a>
            </span>
          </div>
          <div className="footer-left">
            <div className="copyright">
              &copy; {new Date().getFullYear()} AiNXT. All rights reserved.
            </div>
            <div className="terms">
              <span className="terms-text">
                Terms & Conditions: This platform is exclusively designed for Demat Account Opening and Client Onboarding services only.
              </span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;

